import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GoogleDriveDriveEntity } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

export function useGoogleDrivesList(connection: IntegrationConnection) {
  return useQuery({
    queryKey: ["google-drive-drives-list", connection.id],
    queryFn: () => {
      return orgAPI.toolbox.execute<GoogleDriveDriveEntity[]>({
        integration_connection_id: connection.id,
        action_name: "google-drive-drives-list",
        action_input: {},
      });
    },
    enabled: !!connection.id,
  });
}
